var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4142 7.44515C13.9482 7.44866 12.5181 6.99145 11.3259 6.13811V12.0896C11.3255 13.1918 10.9886 14.2677 10.3603 15.1733C9.73189 16.0789 8.84202 16.7711 7.80962 17.1574C6.77723 17.5436 5.65153 17.6054 4.58305 17.3346C3.51456 17.0638 2.55422 16.4732 1.83044 15.6419C1.10666 14.8105 0.653929 13.778 0.532792 12.6824C0.411655 11.5868 0.627883 10.4804 1.15256 9.51099C1.67725 8.5416 2.48537 7.7555 3.46888 7.2578C4.45239 6.76009 5.56441 6.57451 6.65624 6.72586V9.71923C6.15661 9.56208 5.62011 9.56681 5.12334 9.73276C4.62656 9.89871 4.19493 10.2174 3.89007 10.6433C3.58522 11.0692 3.42273 11.5805 3.42582 12.1042C3.4289 12.628 3.5974 13.1374 3.90725 13.5596C4.2171 13.9819 4.65246 14.2955 5.15115 14.4556C5.64985 14.6156 6.18637 14.6141 6.68411 14.451C7.18185 14.288 7.61534 13.9719 7.92269 13.5478C8.23004 13.1237 8.39553 12.6133 8.39551 12.0896V0.455078H11.3259C11.3239 0.702546 11.3446 0.949677 11.3879 1.19335C11.4897 1.7373 11.7014 2.25476 12.0101 2.71408C12.3188 3.1734 12.7179 3.56493 13.1831 3.8647C13.8449 4.3023 14.6208 4.53553 15.4142 4.53537V7.44515Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.cfda7f5e770d8d1eefc4ad3f9fa173dc.svg";
export { ForwardRef as ReactComponent };